import { getQueryStringParameter, clearInputField } from '../../../helpers';

const showBeneficiaryCardOnLoad = ($button) => {
  $('input:not([id$="__destroy"]):not([name*="_destroy]"]):not([name*="is_signator]"]):not([type="hidden"]):not([type="radio"])', ".beneficiary-card")
    .filter(function() { return this.value.length !== 0 })
    .parents('.beneficiary-card')
    .filter(function() { return $('input[id$="__destroy"][name*="_destroy]"]:checked', this).length === 0 })
    .removeClass('d-none');

  const $visibleCards = $('.beneficiary-card:visible');

  if ($visibleCards.length === 10) {
    $button.addClass('d-none');
  }
};

const showFirstBeneficiaryHiddenCard = ($target) => {
  const $hiddenCard = $('.beneficiary-card:hidden:first');
  const $visibleCards = $('.beneficiary-card:visible');
  const $destroyInput = $hiddenCard.find('input[id$="__destroy"]');

  $hiddenCard.removeClass('d-none');
  $destroyInput.prop('checked', false);

  if ($visibleCards.length === 9) {
    $target.addClass('d-none');
  }
};

const destroyBeneficiaryCard = ($target, $button) => {
  const $visibleCards = $('.beneficiary-card:visible');

  $target.parents('.beneficiary-card').addClass('d-none');

  if ($visibleCards.length <= 10 &&  $button.hasClass('d-none')) {
    $button.removeClass('d-none');
  }
};

const toggleBeneficiariesForm = (showForm, $beneficiariesForm, $addBeneficiaryButton) => {
  $beneficiariesForm.toggleClass('d-none', !showForm);
  $addBeneficiaryButton.toggleClass('d-none', !showForm);
};

const displayOtherHoldingTypeField = (holdingTypeSelect, otherHoldingType) => {
  if (holdingTypeSelect.val() === 'other') {
    otherHoldingType.removeClass('d-none');
  } else {
    otherHoldingType.addClass('d-none');

    $('input', otherHoldingType).each((_, inputElement) => {
      clearInputField(inputElement);
    });
  }
}

$(() => {
  const $form = $('form#legal-profile-form');

  if ($form.length === 0 || getQueryStringParameter('id') !== 'beneficiaries') {
    return;
  }

  const $addBeneficiary = $('#addBeneficiary', $form);
  const $destroyBeneficiary = $('input[id^="users_profile_legal_beneficiaries_attributes_"][id$="__destroy"]', $form);
  const $hasDeclaredBeneficiariesCheckbox = $('#has-declared-beneficiaries input[type=checkbox]', $form);
  const $isSoleBeneficiaryCheckbox = $('#is-sole-beneficiary input[type=checkbox]', $form);
  const $beneficiariesForm = $('#beneficiariesForm', $form);
  const $politicallyExposedPersonRadio = $('#politically_exposed_person_radio_buttons input[type=radio]', $form);
  const $politicallyExposedPersonTypeField = $('#politically_exposed_person_type_field', $form);

  $hasDeclaredBeneficiariesCheckbox.on('change', (_e) => {
    toggleBeneficiariesForm(
      !$hasDeclaredBeneficiariesCheckbox[0].checked && !$isSoleBeneficiaryCheckbox[0].checked,
      $beneficiariesForm,
      $addBeneficiary
    );
  });

  $isSoleBeneficiaryCheckbox.on('change', (_e) => {
    toggleBeneficiariesForm(
      !$hasDeclaredBeneficiariesCheckbox[0].checked && !$isSoleBeneficiaryCheckbox[0].checked,
      $beneficiariesForm,
      $addBeneficiary
    );
  });

  showBeneficiaryCardOnLoad($addBeneficiary);
  toggleBeneficiariesForm(
    !$hasDeclaredBeneficiariesCheckbox[0].checked && !$isSoleBeneficiaryCheckbox[0].checked,
    $beneficiariesForm,
    $addBeneficiary
  );

  for (const index of Array(10).keys()) {
    $(`#users_profile_legal_beneficiaries_attributes_${index}_investor_holding_type`).on('change', (_e) => {
      displayOtherHoldingTypeField(
        $(`#users_profile_legal_beneficiaries_attributes_${index}_investor_holding_type`),
        $(`#other-holding-type-${index}`)
      );
    });
  }

  $addBeneficiary.on('click', e => showFirstBeneficiaryHiddenCard($(e.target)));
  $destroyBeneficiary.on('click', e => destroyBeneficiaryCard($(e.target), $addBeneficiary));

  $politicallyExposedPersonRadio.on('change', (e) => {
    if (!e.target.checked) return;

    if (e.target.value === 'true') {
      $politicallyExposedPersonTypeField.removeClass('d-none');
    } else {
      $politicallyExposedPersonTypeField.addClass('d-none');

      $('input', $politicallyExposedPersonTypeField).each((_, inputElement) => {
        clearInputField(inputElement);
      });
    }
  });
});
